export default class Transport {
	id: any;
	name: string;
	description: string;
	img_url: string;
	travel_id: any;
	status_id: any;
	type_id: any;
	prices: any;
	extras: any;
	state_id: any;

	constructor() {
		this.id = null;
		this.name = '';
		this.description = '';
		this.img_url = '';
		this.travel_id = null;
		this.status_id = null;
		this.type_id = null;
		this.state_id = null;
		this.prices = [];
		this.extras = [];
	}

	public static copy(model: any) {
		const aux = new Transport();
		aux.id = model.id;
		aux.name = model.name;
		aux.description = model.description;
		aux.img_url = model.img_url;
		aux.travel_id = model.travel_id;
		aux.status_id = model.status_id;
		aux.type_id = model.type_id;
		aux.prices = model.prices;
		aux.extras = model.extras;
		aux.state_id = model.state_id;
		return aux;
	}
}
